import { Box, SxProps, Theme, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

export type DataGridLayoutProps = {
  /**
   * The id of the DataGrid.
   */
  id: string;

  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * @warning The height of the DataGrid should be at least 400px to accommodate for the minHeight on the DataGrid.
   * If you also include a DataGridHeader child, the height should be at least 450px to accommodate for the
   * minHeight on the DataGrid and the DataGridHeader.
   */
  sx?: SxProps<Theme>;
};

export const DataGridLayout = ({ id, sx, children }: PropsWithChildren<DataGridLayoutProps>) => {
  const theme = useTheme();
  return (
    <Box
      data-testid={`dataGridLayout-${id}`}
      sx={{
        minHeight: '400px',
        height: '100%',
        width: '100%',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        border: `1px solid ${theme.palette.neutral[100]}`,
        borderRadius: '8px',
        // TODO: no VDS token for this value — needs designer input (multi-layer elevation shadow)
        boxShadow:
          '0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12)',
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
